<template>
  <v-menu open-on-hover v-if="imageLink">
    <template #activator="{ props }">
      <v-icon v-bind="props" class="mb-1 ml-1">
        mdi-information-outline
      </v-icon>
    </template>
    <v-card class="pa-3">
      <v-img :src="imageLink" width="500"></v-img>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const server = sl.get('serverProxy');
    const imageLink = ref<string | null>(null);

    onMounted(async () => {
      imageLink.value = await server.getResourceObject('explanation');
    });

    return {
      imageLink,
    };
  },
});
</script>

<style></style>
